// @flow strict

import * as React from 'react';

/**
 * @deprecated legacy hook. Now we have useApiMutation which is backed by react-query
 * and is more powerful.
 */
export function useAsyncAction<A>(action: (...args: A) => mixed): {
  isLoading: boolean,
  // $FlowFixMe need variadic tuple support
  act: (...args: A) => Promise<void>,
} {
  const [isLoading, setIsLoading] = React.useState(false);

  return {
    isLoading,
    act: async (...args) => {
      if (!isLoading) {
        setIsLoading(true);
        try {
          await action(...args);
        } catch (ex) {
          throw ex;
        } finally {
          setIsLoading(false);
        }
      }
    },
  };
}

export function useAsyncActionHandler<A>(action: (...args: A) => mixed): {
  isLoading: boolean,
  error: ?Error,
  // $FlowFixMe need variadic tuple support
  act: (...args: A) => Promise<void>,
} {
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState<?Error>(null);

  return {
    isLoading,
    error,
    act: async (...args) => {
      if (!isLoading) {
        setIsLoading(true);
        setError(null);
        try {
          await action(...args);
        } catch (err) {
          setError(err);
        } finally {
          setIsLoading(false);
        }
      }
    },
  };
}
